export default __webpack_public_path__ + "static/media/loader_optimism.275ebde2.gif";